/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Milling_Process_PlaceholderInputs */

const en_milling_process_placeholder = /** @type {(inputs: Milling_Process_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Washed`)
};

const es_milling_process_placeholder = /** @type {(inputs: Milling_Process_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Lavado`)
};

/**
* | output |
* | --- |
* | "e.g. Washed" |
*
* @param {Milling_Process_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const milling_process_placeholder = /** @type {((inputs?: Milling_Process_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Milling_Process_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_milling_process_placeholder(inputs)
	return es_milling_process_placeholder(inputs)
});